export enum ResourceOption {
  CreateRoom = 'create-room',
  Edit = 'edit',
  Move = 'move',
  Delete = 'delete',
  Duplicate = 'duplicate',
  Rename = 'rename',
  ChangeAccess = 'change-access',
  EditTags = 'edit-tags',
}
